import * as React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import {
  Text,
  Colors,
  ShippingVanBoldIcon,
  InfoCircleIcon,
  TooltipModel,
  breakpoints,
  Tooltip,
} from '@notino/react-styleguide';

import PriceLabel from '@components/PriceLabel';
import { TooltipContent } from '@components/Tooltip/Content';
import { useIsDualPriceForCroatia } from '@containers/ProductDetailContainer/ProductDetail/hooks/useIsDualPriceForCroatia';

import { Condition } from './components/Condition';
import { messages } from './messages';
import { IConditionalFreeDelivery } from './model';
import { DualPriceWrapper } from './styled';
import {
  Wrapper,
  LabelRow,
  PriceWrapper,
  WrapperComponent,
  LineSeparator,
  PriceSplitter,
} from './styled';

interface IConditionalFreeDeliveryProps {
  conditionalFreeDelivery: IConditionalFreeDelivery;
  leftPadding?: boolean;
}

const ConditionalFreeDelivery: React.FC<IConditionalFreeDeliveryProps> = ({
  conditionalFreeDelivery,
  leftPadding,
}) => {
  const { formatMessage } = useIntl();

  const { type, value, targets } = conditionalFreeDelivery;

  const {
    isDualPriceForCroatia,
    getLeftSideFormattedPrice,
    getRightSideFormattedPrice,
    leftSideCurrency,
    rightSideCurrency,
  } = useIsDualPriceForCroatia();

  return (
    <>
      <Wrapper leftPadding={leftPadding}>
        <LabelRow>
          <ShippingVanBoldIcon
            color={Colors.primary}
            width="1.25rem"
            height="1.25rem"
          />

          <Text typography="labelRegular" block={true}>
            {formatMessage(messages[`delivery${type}`], {
              value: type === 'Piece' && value,
              price:
                type === 'Price' &&
                (isDualPriceForCroatia ? (
                  <DualPriceWrapper>
                    <div>
                      {getLeftSideFormattedPrice(value)} {leftSideCurrency}
                    </div>

                    <PriceSplitter>/</PriceSplitter>

                    <div>
                      {getRightSideFormattedPrice(value)} {rightSideCurrency}
                    </div>
                  </DualPriceWrapper>
                ) : (
                  <PriceLabel
                    currencyComponent={PriceWrapper}
                    wrapperComponent={WrapperComponent}
                    price={{ value: value }}
                  />
                )),
            })}
          </Text>
        </LabelRow>

        <Condition targets={targets}>
          <Tooltip
            interactive={true}
            wrapText={true}
            alignDesktop={true}
            breakpointToCenter={breakpoints.xl}
            position={TooltipModel.Position.topCenter}
            content={
              <TooltipContent>
                <FormattedMessage {...messages.tooltipInfo} />
              </TooltipContent>
            }
          >
            <InfoCircleIcon width="13px" height="13px" color={Colors.neutral} />
          </Tooltip>
        </Condition>
      </Wrapper>

      <LineSeparator dashedLine={true} />
    </>
  );
};

export default ConditionalFreeDelivery;
